module.exports = __webpack_public_path__ + "img/erweima-jpg-01.5beadf5f.png";